module.exports = __webpack_public_path__ + "static/media/Gravios.2b31e34c.png";


//////////////////
// WEBPACK FOOTER
// ./src/eggs/images/Gravios.png
// module id = 112
// module chunks = 0